import { render, staticRenderFns } from "./ValuePropCard.vue?vue&type=template&id=70b250e2&scoped=true&lang=pug&"
import script from "./ValuePropCard.vue?vue&type=script&lang=js&"
export * from "./ValuePropCard.vue?vue&type=script&lang=js&"
import style0 from "./ValuePropCard.vue?vue&type=style&index=0&id=70b250e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b250e2",
  null
  
)

export default component.exports